module.exports = __webpack_public_path__ + "img/Federated States of Micronesia.2ac759a5.gif";